import { CartItem, ItemOptionType } from '../api';

function calculateBundlePrice(bundle) {
  return bundle.items.reduce((acc, item) => {
    const componentProduct = bundle.componentProductData.find(
      (p) => String(p.productId) === String(item.productGroup.product.id),
    );
    const componentProductQty = componentProduct?.quantity || 1;

    return (acc + Number(item.product.price)) * componentProductQty;
  }, 0);
}

function mapBundles(cartItems: CartItem[]) {
  const bundles: Record<string, CartItem & any> = cartItems.reduce((acc, item) => {
    const bundleId = item.productBundle?.id;
    const bundle = acc[bundleId];

    if (bundle) {
      acc[bundleId] = { ...bundle, items: [...bundle.items, item] };
    } else {
      acc[bundleId] = { ...item.productBundle, items: [item] };
    }

    return acc;
  }, {});

  return Object.values(bundles).filter((value) => {
    return value.id ? value.componentProductData.length === value.items.length : true;
  });
}

export function calculateSubTotal(cartItems: CartItem[]): number {
  const ENGRAVING_FEE = 50;
  const value: number = Object.values(mapBundles(cartItems)).reduce((acc, bundle) => {
    if (bundle.id) {
      return acc + calculateBundlePrice(bundle) * bundle.items[0].quantity;
    } else {
      return (
        acc +
        bundle.items.reduce((itemsPrices, item) => {
          const engravingTotal =
            item.itemOptions?.type === ItemOptionType.Engraving ? ENGRAVING_FEE * item.quantity : 0;
          return itemsPrices + engravingTotal + item.product.price * item.quantity;
        }, 0)
      );
    }
  }, 0);

  return Number(value.toFixed(2));
}
